module.exports = __webpack_public_path__ + "static/media/Agenda2.a1483e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda2.png
// module id = 1966
// module chunks = 0